var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	52427: {
		fallback: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	56549: {
		fallback: () => (__webpack_require__.e(3942).then(() => (() => (__webpack_require__(23942))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.0.0 || ^16.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "graphql",

	},
	95931: {
		fallback: () => (__webpack_require__.e(3942).then(() => (() => (__webpack_require__(23942))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.9.0 || ^0.10.0 || ^0.11.0 || ^0.12.0 || ^0.13.0 || ^14.0.0 || ^15.0.0 || ^16.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "graphql",

	},
	51263: {
		fallback: () => (__webpack_require__.e(3342).then(() => (() => (__webpack_require__(40961))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	59664: {
		fallback: () => (__webpack_require__.e(1148).then(() => (() => (__webpack_require__(51148))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.15.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bolt/foundations",

	},
	20212: {
		fallback: () => (__webpack_require__.e(8423).then(() => (() => (__webpack_require__(38423))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.4.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/experience-context",

	},
	91834: {
		fallback: () => (__webpack_require__.e(3236).then(() => (() => (__webpack_require__(70855))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.5.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@bolt/components",

	},
	76782: {
		fallback: () => (__webpack_require__.e(2195).then(() => (() => (__webpack_require__(64576))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.100.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/commons",

	},
	35860: {
		fallback: () => (__webpack_require__.e(1286).then(() => (() => (__webpack_require__(98905))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.6.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/i18n",

	},
	92168: {
		fallback: () => (__webpack_require__.e(6068).then(() => (() => (__webpack_require__(26068))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.2.7",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/navigation",

	},
	54037: {
		fallback: () => (__webpack_require__.e(7716).then(() => (() => (__webpack_require__(65335))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.9.11",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@apollo/client",

	},
	34408: {
		fallback: () => (__webpack_require__.e(3942).then(() => (() => (__webpack_require__(23942))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.8.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "graphql",

	},
	42327: {
		fallback: () => (__webpack_require__.e(267).then(() => (() => (__webpack_require__(92648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.30.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	29333: {
		fallback: () => (__webpack_require__.e(2195).then(() => (() => (__webpack_require__(64576))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.x",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/commons",

	},
	27298: {
		fallback: () => (__webpack_require__.e(5744).then(() => (() => (__webpack_require__(53363))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.19.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ue/product-pod",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"267": [
		51263
	],
	"804": [
		52427
	],
	"855": [
		51263,
		52427,
		59664
	],
	"961": [
		52427
	],
	"1407": [
		52427,
		91834,
		35860,
		54037,
		76782,
		20212,
		56549,
		95931,
		34408,
		92168,
		59664,
		42327,
		29333
	],
	"2299": [
		52427,
		59664,
		91834,
		35860,
		20212,
		76782,
		92168,
		42327,
		54037,
		56549,
		95931,
		34408,
		51263,
		29333
	],
	"2648": [
		51263,
		52427
	],
	"3236": [
		51263
	],
	"3363": [
		20212,
		52427,
		59664,
		91834
	],
	"3687": [
		52427
	],
	"3896": [
		52427,
		76782,
		20212,
		91834,
		35860,
		59664,
		92168,
		54037,
		56549,
		95931,
		34408,
		42327,
		51263,
		29333,
		27298
	],
	"4576": [
		52427
	],
	"5335": [
		52427,
		56549,
		95931
	],
	"6734": [
		27298
	],
	"8905": [
		52427
	],
	"9631": [
		52427,
		91834,
		35860,
		20212,
		76782,
		59664,
		92168,
		54037,
		56549,
		95931,
		34408,
		51263,
		29333
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}